import axios from 'axios';
import { ApiResponse, zps_ms_ea_war } from '../../zps';
import { IEntityActivity, IEntityActivityResponse } from '../../entity';

export interface IHelpdeskEntity {
  activity?: number;
  address?: string;
  billingEntity?: number;
  billingVolume?: number;
  contact?: string;
  description?: string;
  email?: string;
  entid?: number;
  gid?: number;
  lang: number;
  logo?: string;
  mobile?: string;
  name?: string;
  nif?: number;
  ownerid?: number;
  postalCode?: string;
  printType?: number;
  region?: string;
  reportType?: number;
  sibsMerchantCode?: string;
  type?: number;
  usePos?: number;
  useShifts?: number;
  maxCurrencies?: number;
}

export interface IHelpdeskEntityResponse extends ApiResponse {
  entities: IHelpdeskEntity[];
  totalRows: number;
  type: string;
  entid?: number;
}

export const fetchEntitiesActivity = (): Promise<IEntityActivity[]> => {
  return axios.get<IEntityActivityResponse>(`${zps_ms_ea_war}/entity/activity`).then(res => res.data.list);
};

export const fetchHelpdeskEntityInfo = (
  entid: number,
  controller: AbortController
): Promise<IHelpdeskEntityResponse> => {
  return axios
    .get<IHelpdeskEntityResponse>(`${zps_ms_ea_war}/entity?entid=${entid}`, {
      signal: controller.signal
    })
    .then(res => res.data);
};

export const fetchHelpdeskEntitiesList = (
  controller: AbortController,
  offset: number,
  limit: number,
  totalRows: boolean,
  type?: string,
  entid?: number,
  name?: string,
  nif?: number
): Promise<IHelpdeskEntityResponse> => {
  const url =
    `${zps_ms_ea_war}/entity?` +
    (type ? `&type=${type}` : '') +
    (entid ? `&entid=${entid}` : '') +
    (name ? `&name=${name}` : '') +
    (nif ? `&nif=${nif}` : '') +
    `&offset=${offset}&limit=${limit}&totalRows=${totalRows}`;

  return axios.get<IHelpdeskEntityResponse>(url, { signal: controller.signal }).then(res => res.data);
};

export const createHelpdeskEntity = (
  request: IHelpdeskEntity,
  controller: AbortController
): Promise<IHelpdeskEntityResponse> => {
  return axios
    .post<IHelpdeskEntityResponse>(`${zps_ms_ea_war}/entity/`, request, { signal: controller.signal })
    .then(res => res.data);
};

export const updateHelpdeskEntity = (
  request: IHelpdeskEntity,
  controller: AbortController
): Promise<IHelpdeskEntityResponse> => {
  return axios
    .put<IHelpdeskEntityResponse>(`${zps_ms_ea_war}/entity/`, request, { signal: controller.signal })
    .then(res => res.data);
};

export const deleteHelpdeskEntity = (entid: number, controller: AbortController): Promise<IHelpdeskEntityResponse> => {
  return axios
    .delete<IHelpdeskEntityResponse>(`${zps_ms_ea_war}/entity?entid=${entid}`, { signal: controller.signal })
    .then(res => res.data);
};
